import { useState } from 'react';

const PRICHINI = [
  ['operator', 'Операторска грешка'],
  ['client', 'Отказана от клиента'],
];

/**
 * Причината за анулиране на започната продажба.
 *
 * Две категории, не свободен текст — така се брои какво реално се
 * случва (грешка на оператора срещу решение на клиента), вместо всеки
 * път да се препише на ръка едно и също изречение. Операторската грешка
 * е по подразбиране: тя е по-честият случай — сгрешена стока или
 * количество, докато въвежда.
 */
export default function VoidReasonModal({
  title, hint, confirmLabel = 'Анулирай', unp, docNumber, onClose, onConfirm,
}) {
  const [prichina, setPrichina] = useState('operator');
  const [busy, setBusy] = useState(false);

  async function confirm() {
    setBusy(true);
    try {
      await onConfirm(PRICHINI.find(([k]) => k === prichina)[1]);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="modal-backdrop" onMouseDown={(e) => {
      if (e.target === e.currentTarget) onClose();
    }}>
      <div className="modal" role="dialog" aria-modal="true">
        <div className="card-head">{title ?? `Анулиране на продажба ${unp ?? docNumber}`}</div>
        <div className="card-body">
          {hint !== null && (
            <p className="hint" style={{ marginTop: 0 }}>
              {hint ?? 'Номерът остава в поредността — така изисква Приложение № 29.'}
            </p>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {PRICHINI.map(([k, label]) => (
              <label key={k} className="check">
                <input type="radio" name="void-reason" checked={prichina === k}
                  onChange={() => setPrichina(k)} />
                {label}
              </label>
            ))}
          </div>
        </div>
        <div className="modal-foot">
          <button onClick={onClose} disabled={busy}>Откажи</button>
          <button className="danger" disabled={busy} onClick={confirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
